interface CerteDriveGlobals {
  config: {
    environment: string;
    honeybadger: {
      apiKey: string;
    };
    logLevel: string;
    stripe: {
      publishableKey: string;
    };
    googleMapsApiKey: string;
  };
  layout: {
    header: boolean;
  };
  paths: {
    [key: string]: string;
  };
  timeOffset: number;
}

declare global {
  interface Window {
    CerteDrive: CerteDriveGlobals;
  }
}

const { CerteDrive } = window;

export const { config, layout, paths, timeOffset } = CerteDrive;

export default CerteDrive;
